import { StaticBaseDao } from '@/dao';
import { FileArchiveItem, FileItemUpdateRequest, GuidArray } from '@/objects/generated';

export class FileArchiveDao extends StaticBaseDao {
    public static async GetMyFiles(eventID?: number | null): Promise<FileArchiveItem[]> {
        return this.BaseFetchArray(
            FileArchiveItem,
            `FileArchive/GetMyFiles` + '?' + (eventID == undefined ? '' : `eventID=${eventID}`),
            'GET',
        );
    }
    public static async GetFilesForEvent(eventId: number): Promise<FileArchiveItem[]> {
        return this.BaseFetchArray(
            FileArchiveItem,
            `FileArchive/GetFilesForEvent` + '?' + (eventId == undefined ? '' : `eventId=${eventId}`),
            'GET',
        );
    }
    public static async DownloadFile(
        fileguid: string,
    ): Promise<{ stream: ReadableStream<Uint8Array> | null; contentType: string | null; filename?: string }> {
        return this.GetRaw(`FileArchive/DownloadFile` + '?' + (fileguid == undefined ? '' : `fileguid=${fileguid}`));
    }
    public static async UploadFiles(files: FormData, eventId: number | null): Promise<FileArchiveItem[]> {
        return this.PostFormData(
            FileArchiveItem,
            `FileArchive/UploadFiles` +
                '?' +
                (files == undefined ? '' : `files=${files}`) +
                '&' +
                (eventId == undefined ? '' : `eventId=${eventId}`),
            files,
        );
    }
    public static async UpdateFileItem(files: FileItemUpdateRequest[]): Promise<GuidArray | null> {
        return this.BaseFetch(GuidArray, `FileArchive/UpdateFileItem`, 'POST', files);
    }
    public static async DeleteFiles(filesGuids: GuidArray): Promise<GuidArray | null> {
        return this.BaseFetch(GuidArray, `FileArchive/DeleteFiles`, 'POST', filesGuids);
    }
    public static async PublishFiles(filesGuids: GuidArray): Promise<GuidArray | null> {
        return this.BaseFetch(GuidArray, `FileArchive/PublishFiles`, 'POST', filesGuids);
    }
    public static async UnpublishFiles(filesGuids: GuidArray): Promise<GuidArray | null> {
        return this.BaseFetch(GuidArray, `FileArchive/UnpublishFiles`, 'POST', filesGuids);
    }
}
